<template>
  <div class="container">
    <div class="content">
      <home-footer-text title="用户帮助" link1="如何注册成为买家或卖家？" link2="如何查好货源？" link3="如何发布会货源？" link4="如何发布会求购？"></home-footer-text>
    </div>
    <div class="content">
      <home-footer-text title="常见问题" link1="如何安装木材码头APP" link2="线上交易流程" link3="为什么要做信息认证？" link4="服务站是什么？"></home-footer-text>
    </div>
  </div>
</template>

<script>
  import HomeFooterText from './HomeFooterText.vue'
  export default {
    name: 'homeFooterLeft',
    components: {
      HomeFooterText
    }
  }
</script>

<style scoped>
  div.container {
    display: flex;
    padding: 0;
    width: auto;
  }
  div.content {
    margin: auto;
    width: auto;
    float: left;
  }

</style>



// WEBPACK FOOTER //
// HomeFooterLeft.vue?0fa96fcc